import { useState, useEffect } from 'react';

import API from 'service/api';
import Util from 'service/util';
import Loading from 'component/Loading';
import NoData from 'component/NoData';

const LCRModal = ({owner}) =>
{
  const [data, setData] = useState(null);

  useEffect(() => {
    API.getLicenseChangeRecord(owner.id).then(data => {
      setData(data);
    });
  }, []);

  if (null == data) return <>
    <Loading />
    <p className="message yellow">正在載入...</p>
  </>;

  if (0 == data.length) return <NoData />;

  return (
    <table className="data-table lcrhis-table">
      <colgroup>
        <col width="auto" id="col-lcrhis-date"/>
        <col width="auto" id="col-lcrhis-old-lic"/>
        <col width="auto" id="col-lcrhis-new-lic"/>
        <col width="auto" id="col-lcrhis-mod-by"/>
      </colgroup>
      <thead>
        <tr>
          <th className="col-lcrhis-date">日期</th>
          <th className="col-lcrhis-old-lic">舊車牌</th>
          <th className="col-lcrhis-new-lic">新車牌</th>
          <th className="col-lcrhis-mod-by">修改人</th>
        </tr>
      </thead>
      <tbody>
      { data.map(r =>
        <tr key={new Date(r.mod_dtm).valueOf()}>
          <td className="col-lcrhis-date" title={ Util.FullDate(r.mod_dtm)}>{ Util.ShortDate(r.mod_dtm) }</td>
          <td className="col-lcrhis-old-lic">{ r.old_license }</td>
          <td className="col-lcrhis-new-lic">{ r.new_license }</td>
          <td className="col-lcrhis-mod-by">{ r.mod_by }</td>
        </tr>
      )}
      </tbody>
    </table>
  );
}

export default LCRModal